<div mat-dialog-content style="width: 320px;">
  <p> put your tracking details</p>
  <mat-form-field>
    <input matInput type="url" placeholder=" tracking URL" [(ngModel)]="url" >
  </mat-form-field>
  <mat-form-field>
    <input matInput type="text"  placeholder="Tracking number" [(ngModel)]="trackingNumber" >
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button class="pblsh-mat-btn" mat-raised-button (click)="save()">Save</button>
</div>
